import { define } from 'wicked-elements'
import onIntersect from '../lib/on-intersect.js'

define('[data-component~="infinite-scroll"]', {
  init () {
    this.state = {}
    this.onEnter = this.onEnter.bind(this)
    this.containerSelector = this.element.dataset.container
    this.linkSelector = this.element.dataset.link
    this.$container = document.querySelector(this.containerSelector)
    this.$link = document.querySelector(this.linkSelector)
  },
  connected () {
    this.stopObserving = onIntersect(this.element, this.onEnter)
    this.element.style.opacity = 0
  },
  disconnected () {
    this.stopObserving()
  },
  onEnter (e) {
    this.stopObserving()
    this.getNextPage()
  },
  getNextPage () {
    if (!this.$link.href) return
    
    fetch(this.$link.href)
      .then(response => response.text())
      .then(html => this.parseAndAppend(html))
      .catch(err => console.warn('Something went wrong.', err))
  },
  parseAndAppend (html) {
    let parser = new DOMParser()
    let doc = parser.parseFromString(html, 'text/html')
    let $tempContainer = doc.querySelector(this.containerSelector)
    if ($tempContainer) {
      [...$tempContainer.children].forEach(node => {
        this.$container.appendChild(node)  
      })
      this.updatePaginationLink(doc)
    }
  },
  updatePaginationLink (doc) {
    let $tempLink = doc.querySelector(this.linkSelector)
    let nextUrl = $tempLink ? $tempLink.href : false
    if (nextUrl) {
      this.$link.href = nextUrl
      this.stopObserving = onIntersect(this.element, this.onEnter)
    } else {
      this.element.remove()
    }
  }
})